(function ($) {

'use strict';

	/**
	 * Create and show a Messi dialog with an OK button.
	 * @param {string} title
	 * @param {string} message
	 * @param {string} dlgType 'info' (blue titlebar) | 'anim error' (red animated titlebar) | 'success' (green titlebar)
	 * @param {object} extraMessiOptions i.e. { callback: function() {...} }
	 * @returns {Messi} dialog
	 */
	$.showMessiDlgToConfirm = function (title, message, dlgType, extraMessiOptions) {
		// ensure Messi is loaded
		return $.initMessi(function () {
			var messiDlg = new Messi(message.replace('\\n', '<br />'),
					$.extend({title: title,
						titleClass: (typeof dlgType === 'string' ? dlgType : 'success')},
							$.morejs_options.messi.defaultOpt,
							$.morejs_options.messi.position(),
							$.morejs_options.messi.confirmDlg,
							(extraMessiOptions || {})));

			// set focus to the first button in the dialog
			setTimeout(function () {
				$('button.btn').first().focus();
			}, 100);

			return messiDlg;
		});
	};	// $.showMessiDlgToConfirm

}(jQuery));